import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';
import { AvailabilityComponent } from './availability.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';



@NgModule({
  declarations: [
    AvailabilityComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropzoneModule,
    NgxJsonViewerModule
  ],
  exports: [
    AvailabilityComponent
  ]
})
export class AvailabilityModule { }